import {Punto} from "./Punto";
import {Marcador} from "./Marcador";
import {LatLngTuple, MapOptions} from "leaflet";
import * as L from "leaflet";
import {Location} from '../modelos/location';

export class EstadoMapa {
  centro: Punto;
  zoom: number;
  marcadores: Marcador[];
  maxBoundsMexico: LatLngTuple[] = [
    [14.3886243, -86.493266], //Southwest
    [32.7186553, -118.599188]  //Northeast
  ];

  constructor(centro: Punto, zoom: number, marcadores: Array<Marcador>) {
    this.centro = centro;
    this.zoom = zoom;
    this.marcadores = marcadores;
  }

  public static construirEstadoInicial() {
    let centro = new Punto(28.6523808, -106.0902046);
    let zoom = 12;
    let marcadores: Marcador[] = [];
    return new EstadoMapa(centro, zoom, marcadores);
  }

  public static construirEstadoMapa(centro: Punto, zoom: number) {
    return new EstadoMapa(centro, zoom, []);
  }

  public static construirEstadoMapaConMarcadores(centro: Punto, zoom: number, marcadores: Array<Marcador>) {
    return new EstadoMapa(centro, zoom, marcadores);
  }

  public getEstadoParaLeafletjs(): L.MapOptions {
    const location = new Location();
    location.latlng = L.latLng(this.centro.latitud, this.centro.longitud);

    let estado: L.MapOptions = {
      center: location.latlng,
      zoomControl: false,
      zoom: this.zoom,
      maxBounds: this.maxBoundsMexico
    }
    return estado;
  }

  public agregarMarcador(marcador: Marcador) {
    this.marcadores.push(marcador);
  }

  public eliminarMarcador(idMarcador: string) {
    for (let i = 0; i < this.marcadores.length; i++) {
      if (this.marcadores[i].id == idMarcador) {
        this.marcadores.splice(i, 1);
        break;
      }
    }
  }
}
